import clsx from 'clsx'
import { Link } from 'react-router-dom'

import { usePaginatedAssignmentList, Spin } from '@pepper/ui'

import StagePill from 'components/StagePill/StagePill'

import styles from './_.module.css'

interface LinkedItemsProps {
  groupId: number
  projectId: string
  assignmentId: string
  isPage?: boolean
}

const LinkedItems = ({
  groupId,
  assignmentId,
  projectId,
  isPage = false,
}: LinkedItemsProps): JSX.Element | null => {
  const { records: assignments, isLoading } = usePaginatedAssignmentList({
    project_id: projectId,
    group_id: groupId,
    stage: ['all'],
  })

  if (isLoading || !Array.isArray(assignments)) {
    return <Spin className={styles.spin} />
  }

  if (assignments?.length < 2) return null

  return (
    <div className={clsx(styles.wrapper, { [styles.page]: isPage })}>
      <span className={styles.note}>Other items linked to this item</span>
      {assignments.length > 0 && (
        <ul className={styles.list}>
          {assignments
            .filter(_assignment => _assignment.id !== assignmentId)
            .map(assignment => {
              const link = isPage
                ? `/assignment/${assignment.id}/linked-items?project_id=${assignment.project.id}`
                : `/project/${assignment.project.id}?view_assignment=${assignment.id}&project_title=${assignment.project.title}`

              return (
                <li className={styles.item} key={assignment.id}>
                  <div className={styles.left}>
                    <span className={styles.code}>
                      #{assignment.assignment_code}
                    </span>
                    <span className={styles.title}>
                      <Link to={link}>{assignment.assignment_title}</Link>
                    </span>
                    <span className={styles.pill}>
                      {assignment.vertical.name}
                    </span>
                  </div>
                  <div className={styles.right}>
                    <span>
                      <StagePill stage={assignment.stage} />
                    </span>
                  </div>
                </li>
              )
            })}
        </ul>
      )}
    </div>
  )
}

export default LinkedItems
